import {h, Fragment} from "preact"
import { useAppState, useFacets } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"

import Sidebar from "./Sidebar"
import VisualFacet from "./VisualFacet"
import Toolbar from "./Toolbar"
import Products from "./Products"
import LoadMore from "./LoadMore"
import NoResults from "./NoResults"

import { categoryVisuals } from "../config"

export default function Category() {
    const { response: { products }, loading } = useAppState();
    const { facets } = useFacets();
    const [ categoryImageFacet, setCategoryImageFacet ] = useState(null);
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    const foundProducts = products && products.total > 0;

    useEffect(() => {
        const facetMatch = categoryVisuals.find(category => category.id === products?.categoryId);
        if(!facetMatch) return;
        setCategoryImageFacet(
            facets.find(facet => facet.name === facetMatch.name)
        )
    }, [ facets, products?.categoryId, categoryVisuals ]);
    
    useEffect(() => {
        document.querySelector('body')?.classList?.toggle('overflow-hidden', sidebarOpen);
        return () => document.querySelector('body')?.classList?.remove('overflow-hidden');
    }, [ sidebarOpen ])

    const toggleSidebar = () => {
        setSidebarOpen(prevSidebarOpen => !prevSidebarOpen)
    }

    return (
        <div className="ns-serp">
            {foundProducts ? (
                <>
                    <Sidebar 
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                    />
                    {(categoryImageFacet) && (
                        <VisualFacet 
                            facet={categoryImageFacet}
                        />
                    )}
                    <div className="ns-serp-innner ns-flex ns-flex-col">
                        <Toolbar 
                            toggleSidebar={toggleSidebar}
                        />
                        <Products />
                        <LoadMore />
                    </div>
                </>
            ) : loading ? (
                null
            ) : (
                <NoResults />
            )}
        </div>
    )
}


